export enum SYSTEM_TYPE {
  AC_SYSTEM = 'AC_SYSTEM',
  DC_SYSTEM = 'DC_SYSTEM',
  CUSTOM_SYSTEM = 'CUSTOM_SYSTEM',
}
